import { modulesProperties } from "@utils/enums/api/module.enum";
import { ApiErrorCodeDuplicates } from "@type/core/api/api.types";

const moduleIndex = 0;
const featureIndex = 1;
const errorIndex = 2;

const getCookie = (cname: string): string => {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const getJseAuthCookie = (): string => {
  return getCookie("JSE-AUTH");
};

export const getToken = (): string => {
  // console.log(localStorage.getItem("persist:root"))
  // JSON.parse(JSON.parse(localStorage.getItem("persist:root")).auth2)
  return getCookie("ECMA-TOKEN");
  // JSON.parse(JSON.parse(localStorage.getItem("persist:root")).auth2).auth2Token;
};

const computeErrorLabelKey = (errorCode: string): string => {
  const v = errorCode.split("-");

  const prefix = ["api", "errors", "codes"];

  if (v.length === 1) {
    return [...prefix, v[0]].join(".");
  }

  return [
    ...prefix,
    modulesProperties[v[moduleIndex]].code,
    v[featureIndex],
    v[errorIndex],
  ].join(".");
};

const computeErrorCodesDuplicates = (
  values: string[],
): ApiErrorCodeDuplicates => {
  return values.reduce(function (acc: ApiErrorCodeDuplicates, obj: string) {
    const cle = obj;
    if (!acc[cle]) {
      acc[cle] = 0;
    }
    acc[cle] = acc[cle] + 1;
    return acc;
  }, {});
};

export const apiHelper = {
  computeErrorLabelKey: computeErrorLabelKey,
  computeErrorCodesDuplicates: computeErrorCodesDuplicates,
};
